enum TransactionDisplayType {
  MORSOM_SPARING = 'MORSOM_SPARING',
  DEBIT_CARD = 'DEBIT_CARD',
  VISA_CARD = 'VISA_CARD',
  CREDIT_CARD = 'CREDIT_CARD',
  UBETJENT = 'UBETJENT',
  ATM = 'ATM',
  LOAN = 'LOAN',
  SALARY = 'SALARY',
  PENSION = 'PENSION',
  INT_PAY = 'INT_PAY',
  DOM_PAY = 'DOM_PAY',
  EFAKTURA = 'EFAKTURA',
  TRANSFER = 'TRANSFER',
  VIPPS = 'VIPPS',
  BUS_PAY = 'BUS_PAY',
  OTHER = 'OTHER',
}

export default TransactionDisplayType;
